import Config from 'Config';
import SuperAgent from 'superagent';

class SoundCloud {
  constructor() {
    this.url = Config.soundCloudRoot;
  }

  oEmbed(url, callback) {
    SuperAgent.get(this.url + 'oembed?format=json&url=' + escape(url))
      .set('Content-Type', 'text/plain')
      .set('Accept', 'application/json')
      .end((err, response) => {
        if (callback) {
          callback(response.body);
        }
      });
  }
}

export default new SoundCloud();



// WEBPACK FOOTER //
// ./src/js/services/SoundCloud.js